import { Component, Input, OnInit } from '@angular/core';
/**
 * Component to display a icon
 *
 * @example
 *<cfe-icon [iconName]="'monitor'"></cfe-icon>
 */

@Component({
	selector: 'cfe-icon',
	templateUrl: './icon.component.html',
	styleUrls: ['./icon.component.scss']
})
export class IconComponent implements OnInit {
	@Input() iconName: string;
	constructor() {}

	ngOnInit() {}
}
